// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__13okm","large":"styles_large__3_Wqc"};